import React from 'react'
import FooterLinkedin from "./images/linkedin-filled.svg"
import FooterGithub from "./images/githubIcon.svg"
import FooterBehance from "./images/behanceIcon.svg"

export default function Footer(){
    return(
        <footer>
           <div>  
                <a href="https://www.linkedin.com/in/michele-carson/" target="_blank">
                <img className="footer-icons" src={FooterLinkedin}/></a>

                <a href="https://github.com/michelecarson" target="_blank">
                <img className="footer-icons" src={FooterGithub}/></a>

                <a href="https://www.behance.net/michelecarson" target="_blank">
                <img className="footer-icons" src={FooterBehance}/></a>
            </div>
            <p>Designed and developed by Michele Carson</p>
            <p>&copy; 2023 All Rights Reserved</p>
        </footer>
    )
}